import { useEffect } from 'react';
import { useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

interface Props {
  steps: any;
  keyValue: string;
  callback?: any;
  elementId?: any;
}

const GuideTour = ({ steps = [], keyValue, callback, elementId = null }: Props) => {
  const [run, setRun] = useState(false);
  const [margin, setMargin] = useState('');
  useEffect(() => {
    setTimeout(() => {
      setRun(true);
    }, 0);
  }, []);
  const scrollToTop = () => {
    if (!elementId) return;
    const container = document.getElementById(elementId) as HTMLDivElement;
    container.scroll({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <Joyride
      steps={steps}
      callback={({ status, step }: any) => {
        if (step?.margin) {
          setMargin(step.margin);
        } else if (margin != '') {
          setMargin('');
        }
        if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
          window.localStorage.setItem(keyValue, 'true');
          scrollToTop();
          if (callback) callback();
        }
      }}
      run={run}
      showProgress
      showSkipButton
      continuous
      hideCloseButton
      hideBackButton
      scrollToFirstStep
      disableScrollParentFix
      disableOverlayClose
      scrollOffset={80}
      styles={{
        buttonSkip: {
          textDecoration: 'underline',
          color: '#f2f2f2'
        },
        buttonNext: {
          outline: 'none',
          boxShadow: '-3px 0 12px 0 rgba(0, 0, 0, 0.5)',
          backgroundColor: '#2d2c2e'
        },
        tooltip: {
          backgroundColor: '#030303',
          borderRadius: '15px',
          border: 'solid 2px #37343f',
          padding: 0
        },
        tooltipTitle: { color: '#6e6c73', paddingTop: '5px', fontWeight: 'normal' },
        tooltipContent: {
          color: '#fff',
          paddingTop: '5px',
          fontSize: '14px'
        },
        tooltipFooter: { margin: '10px' },
        options: {
          arrowColor: '#37343f',
          zIndex: 10000,
          overlayColor: 'rgba(0, 0, 0, 0.8)'
        },
        spotlight: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'red',
          margin: margin,
          padding: 0
        }
      }}
    />
  );
};

export default GuideTour;
